import script from "./newHomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./newHomePage.vue?vue&type=script&setup=true&lang=js"

import "./newHomePage.vue?vue&type=style&index=0&id=5ab339e8&lang=css"

const __exports__ = script;

export default __exports__